export function salvarAvaliacaoAcao(codigoItem, campos, idenArquivo) {
  //Monta a URL com o parametro idenArquivo  
  const url = idenArquivo 
              ? `/acaorags/avaliacoes/${codigoItem}?idenArquivo=${idenArquivo}` //caso existir o arquivo
              : `/acaorags/avaliacoes/${codigoItem}`; //caso nao existir o arquivo
  return new Promise((resolve, reject) => {
    window.$http.put(url, JSON.stringify(campos))
      .then((res) => {
      resolve(res.data); 
    });
  });
}

export function salvarAvaliacaoAcao2024(codigoItem, campos, idenArquivo, codgProduto) {
  //Monta a URL com o parametro idenArquivo  
  const url = idenArquivo 
              ? `/acaorags/avaliacoes/${codigoItem}/${codgProduto}?idenArquivo=${idenArquivo}` //caso existir o arquivo
              : `/acaorags/avaliacoes/${codigoItem}/${codgProduto}`; //caso nao existir o arquivo
  return new Promise((resolve, reject) => {
    window.$http.put(url, JSON.stringify(campos))
      .then((res) => {
      resolve(res.data); 
    });
  });
}

export function salvarRealizadoRegiaoPlan(dados) {
  return new Promise((resolve, reject) => {
    window.$http.put(`/realizadoptamonrgplas/atualizarrealregiaoplan`, JSON.stringify(dados)).then((res) => {
      resolve(res);
    });
  });
}

export function buscaIndicadorPorIdenPtaFiplan(idenPtaFiplan) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`pta-fiplan-indicadores/v1/all/${idenPtaFiplan}`).then((res) => {
      resolve(res);
    });
  });
}

export function buscaAnaliseAcaoIndicador(idenPtaMonitora) {
  return new Promise(async (resolve, reject) => {
    window.$http.get(`/v1/analise/acao/indicadors/all/apuracao-analise/${idenPtaMonitora}`).then((res) => {
      resolve(res);
    });
  });
}

export function deletarAnaliseAcaoIndicador(idenAnaliseAcaoIndicador) {
  return new Promise(async (resolve, reject) => {
    window.$http.delete(`v1/analise/acao/indicadors/${idenAnaliseAcaoIndicador}`).then((res) => {
      resolve(res);
    });
  });
}

export function editarAnaliseAcaoIndicador(idenAnaliseAcaoIndicador, campos) {
  return new Promise((resolve, reject) => {
    window.$http.put(`v1/analise/acao/indicadors/${idenAnaliseAcaoIndicador}`, JSON.stringify(campos)).then((res) => {
      resolve(res.data);
    });
  });
}

export function salvarAnaliseAcaoIndicador(campos) {
  return new Promise((resolve, reject) => {
    window.$http.post(`v1/analise/acao/indicadors`, JSON.stringify(campos)).then((res) => {
      resolve(res.data);
    });
  });
}

export async function uploadArquivoRAG(file) {
  // Cria uma instância de FormData e anexa o arquivo
  const formData = new FormData();
  formData.append('file', file);  
  if (file) {
    try {    
      return new Promise((resolve, reject) => {
        window.$http.post(`/arquivorag/upload`, formData).then((res) => {
          resolve(res.data);
        });
      });    
    } catch (error) {
      console.error('Erro ao enviar arquivo:', error);
      throw error;
    }
  }  
}

export function downloadArquivoRAG(idenArquivo) {
  return new Promise((resolve, reject) => {
    window.$http
      .get(`/arquivorag/download/base64/${idenArquivo}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export async function buscarPeloCodigo(codigo) {
  return new Promise((resolve, reject) => {
    window.$http
      .get(`/arquivorag/buscar/${codigo}`)
      .then((res) => {
        resolve(res.data); // Retornando o corpo do arquivo
      })
      .catch((err) => {
        reject(err); // Repassa o erro
      });
  });
}

export function buscaTipoSugestaoMelhoria(stringTipo) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/tiposugestaomelhoria/${stringTipo}`).then((res) => {
      resolve(res);
    })
      .catch((err) => {
        reject(err);      
    });
  });
}

export function adicionarSugestaoMelhoria(camposSM,tipoNivel) {
  return new Promise((resolve, reject) => {
    window.$http.post(`/sugestaomelhoria/${tipoNivel}`, JSON.stringify(camposSM)).then((res) => {
      resolve(res.data);
    })
      .catch((err) => {
        reject(err);
      });
  });
}

export function buscaSugestaoMelhoriaGeral(tipoNivel, idenPesquisa) {
  return new Promise((resolve, reject) => {
    window.$http.get(`/sugestaomelhoria/sugestoes/${tipoNivel}/${idenPesquisa}`).then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    });    
  });
}

export function excluirSugestaoMel(idenSugestaoMelhoria) {
  return new Promise((resolve, reject) => {
    window.$http.delete(`/sugestaomelhoria/${idenSugestaoMelhoria}`).then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function editarSugestaoMel(idenSugestaoMelhoria, camposSM) {
  return new Promise((resolve, reject) => {
    window.$http.put(`/sugestaomelhoria/${idenSugestaoMelhoria}`, JSON.stringify(camposSM)).then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}